import { IndividualCallScreen } from "./IndividualCallScreen";

export default IndividualCallScreen;
